import {ToastService} from "../services/ToastService";
import {LcrAnalyticsEvent} from "../directives/event-tracking-directives";
import {OENavCtrl} from "../controllers/oe/nav";
import {StaticPageUsageLoggingService} from "../services/StaticPageUsageLoggingService";
import {htmlToPlaintext} from "../utility/htmlToPlainText";

class SimpleSmapAppConfig {
    $inject = [];

    getApplication() {
        return 'smap_v2';
    }
}

export module appPageStatic {
    export function init(): void {
        let dependencies = ['ui.bootstrap.dropdown', 'ngSanitize', 'ngPasswordStrength'];

        let map = angular.module('map', dependencies);
        map.filter("sanitize", ['$sce', function($sce) {
                return function(htmlCode){
                    return $sce.trustAsHtml(htmlCode);
                }
            }])
            .config(['$locationProvider', function($locationProvider) {
                $locationProvider.html5Mode({
                    // Leave this in because otherwise it breaks Glossary links!
                    enabled: true,
                    requireBase: false,
                    rewriteLinks: false
                }).hashPrefix('!');
            }])
            .factory('errorHttpInterceptor', ['$q', function ($q : angular.IQService) {
                return {
                    'request': function (request) {
                        if (request.url.indexOf('/api') === 0 && request.transformResponse && request.transformResponse.push) {
                            request.transformResponse.push((data, headersGetter, status) => {
                                if (status == 403) {
                                    console.log('403 error, is user logged in?');
                                    console.log(request);
                                    console.log(data);
                                    console.log(status);
                                }

                                return data;
                            });
                        }
                        return request;
                    },
                    'response': function (response) {
                        // intercept error responses
                        if (typeof  response.data == 'object' && response.data['error']) {
                            return $q.reject(response.data);
                        }
                        return response;
                    }
                }
            }])
            .config(['$httpProvider', function ($httpProvider : angular.IHttpProvider) {
                $httpProvider.interceptors.push('errorHttpInterceptor');
            }])
            .filter('htmlToPlainText', () => {
                return htmlToPlaintext;
            })
            .service('appConfig', SimpleSmapAppConfig)
            // .service('portalServices', PortalServices)
            // .service('landcareMapService', Stubs.MapService)
            .service('usageLoggingService', StaticPageUsageLoggingService)
            // .service('queueService', QueueService)
            .directive('lcrAnalyticsEvent', LcrAnalyticsEvent.factory())
            // .directive('ltTileLoadIndicator', TileLoadIndicator.factory())
            // .directive('ltMapView', MapView.factory())
            // .directive('ltToolbar', LtToolbar.factory())
            // .directive('ltTreeMap', TreeMap.factory())
            // .directive('ltBubbleChart', LtBubbleChart.factory())
            // .directive('ltBarChart', LtBarChart.factory())
            // .directive('errorColour', ErrorColour.factory())
            // .directive('isIndeterminate', IsIndeterminate.factory())
            // .service('loginService', LoginService)
            // .directive('loggedInClick', LoggedInClick.factory())
            // .controller('loginModalCtrl', LoginModalCtrl)
            .service('toastService', ToastService)
            // .service('searchService', SearchService)
            // .service('pinService', PinService)
            // .service('legendService', LegendService)
            // .service('mapShareService', MapShareService)
            // .service('layerQueryService', LayerQueryService)
            // .service('areaQueryService', OEAreaQueryService)
            // .service('settingsService', SettingsService)
            // .service('customLayerService', CustomLayerService)
            // .service('coordinateAdjustmentService', TransparentPaneCoordinateAdjustmentService)
            // .controller('modalInstanceCtrl', ModalInstanceCtrl)
            // .controller('searchPaginationCtrl', SearchPaginationCtrl)
            // .controller('geoAppCtrl', GeoAppCtrl)
            // .controller('layerGroupCtrl', LayerGroupCtrl)
            // .service('contextFeatureMarkupService', ContextFeatureMarkupService)
            // .service('pinExtraDataService', PinExtraDataService)
            // .controller('wfsResultsCtrl', WfsResultsCtrl)
            // .service('pointQueryFeatureService', PointQueryFeatureService)
            // .controller('layerSelectorCtrl', LayerSelectorCtrl)
            // .controller('layerSettingsCtrl', LayerSettingsCtrl)
            // .controller('customLayerCtrl', CustomLayerCtrl)
            // .controller('pointQueryCtrl', PointQueryCtrl)
            // .controller('searchCtrl', SearchCtrl)
            // .controller('activeCtrl', ActiveCtrl)
            .controller('navCtrl', OENavCtrl)
            // .controller('pinsCtrl', PinsCtrl)
            // .service('printService', PrintService)
            // .controller('printCtrl', PrintCtrl)
            // .controller('mapShareCtrl', MapShareCtrl)
            // .controller('areaQueryCtrl', AreaQueryCtrl)
            // .controller('areaQueryChartCtrl', AreaQueryChartCtrl)
            // .controller('settingsCtrl', SettingsCtrl);
    }
}
